import { render, staticRenderFns } from "./Document_details_complete.vue?vue&type=template&id=6e2a9cc6&scoped=true&"
import script from "./Document_details_complete.vue?vue&type=script&lang=js&"
export * from "./Document_details_complete.vue?vue&type=script&lang=js&"
import style0 from "./Document_details_complete.vue?vue&type=style&index=0&id=6e2a9cc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2a9cc6",
  null
  
)

export default component.exports